(function(){
  if (window.__spLabelHighlightInit) return;
  window.__spLabelHighlightInit = true;
  if (!/\/collections\/(lab-diamonds|diamonds)/.test(location.pathname)) return;

  // ─── (A) Basic panel: .sp-bn__col with data-i ticks ──────────────────
  function applyBasicPanel(){
    document.querySelectorAll('.sp-bn__col').forEach(function(col){
      var key = col.getAttribute('data-key');
      var ticks = col.querySelectorAll('.sp-bn__tick[data-i]');
      if (!ticks.length) return;

      var minH = col.querySelector('.sp-rng__handle--min, input[type="range"].sp-rng__handle--min');
      var maxH = col.querySelector('.sp-rng__handle--max, input[type="range"].sp-rng__handle--max');
      if (!minH || !maxH) return;
      var lo = parseFloat(minH.value), hi = parseFloat(maxH.value);
      if (isNaN(lo) || isNaN(hi)) return;

      // Tolerance: allow the endpoint tick to count as in-range.
      ticks.forEach(function(t){
        var i = parseFloat(t.getAttribute('data-i'));
        if (isNaN(i)) return;
        var inRange = i >= Math.floor(lo) - 0.001 && i <= Math.ceil(hi) + 0.001;
        t.classList.toggle('is-sp-in-range', inRange);
      });
    });
  }

  function wireBasicPanel(){
    document.querySelectorAll('.sp-bn__col').forEach(function(col){
      if (col.__spBasicWired) return;
      col.__spBasicWired = true;
      col.querySelectorAll('input[type="range"]').forEach(function(inp){
        inp.addEventListener('input',  applyBasicPanel);
        inp.addEventListener('change', applyBasicPanel);
      });
    });
  }

  // ─── (B) Advanced panel: noUiSlider raw filter widgets ───────────────
  var ADVANCED_GROUPS = [
    { wrapSel: '#filter__color' },
    { wrapSel: '#filter__clarity' },
    { wrapSel: '.filter__cut' },
    { wrapSel: '.filter__polish' },
    { wrapSel: '.filter__symmetry' },
    { wrapSel: '.filter__fluorescence' }
  ];
  function isVisible(el){
    if (!el) return false;
    if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function pickVisibleWrap(sel){
    var all = document.querySelectorAll(sel);
    for (var i = 0; i < all.length; i++) if (isVisible(all[i])) return all[i];
    return null;
  }
  function highlightByPosition(slider, labels){
    if (!slider || !labels || !labels.length) return;
    var handles = slider.querySelectorAll('.noUi-handle');
    if (handles.length < 2) return;
    var h0 = handles[0].getBoundingClientRect();
    var h1 = handles[1].getBoundingClientRect();
    if (h0.width === 0 || h1.width === 0) return;
    var leftX  = Math.min(h0.left + h0.width / 2, h1.left + h1.width / 2);
    var rightX = Math.max(h0.left + h0.width / 2, h1.left + h1.width / 2);
    var tol = 8;
    labels.forEach(function(l){
      var r = l.getBoundingClientRect();
      var centerX = r.left + r.width / 2;
      l.classList.toggle('is-sp-in-range', centerX >= leftX - tol && centerX <= rightX + tol);
    });
  }
  var ADV_WIRED = {};
  function wireAdvanced(g){
    if (ADV_WIRED[g.wrapSel]) return ADV_WIRED[g.wrapSel];
    var wrap = pickVisibleWrap(g.wrapSel);
    if (!wrap) return null;
    var slider = wrap.querySelector('.range-slider');
    if (!slider) return null;
    var labels = Array.prototype.slice.call(
      wrap.querySelectorAll('.filter-bottom-label, .filter-label, .cut-filter-label, .filter-labels > p, .filter-labels > span, .cut-filter-labels > p, .cut-filter-labels > span')
    );
    labels = labels.filter(function(el, i){ return labels.indexOf(el) === i; });
    if (!labels.length) return null;

    var entry = { slider: slider, labels: labels };
    ADV_WIRED[g.wrapSel] = entry;
    function run(){ highlightByPosition(slider, labels); }
    if (slider.noUiSlider) {
      try { slider.noUiSlider.on('update.spLabel', run); } catch(e){}
    }
    window.addEventListener('resize', run);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    return entry;
  }
  function runAdvanced(){
    ADVANCED_GROUPS.forEach(function(g){
      var entry = wireAdvanced(g);
      if (entry) highlightByPosition(entry.slider, entry.labels);
    });
  }

  // ─── Orchestrator ───────────────────────────────────────────────────
  function runAll(){
    wireBasicPanel();
    applyBasicPanel();
    runAdvanced();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();

  // Poll for a short while so late-mounted sliders still pick up the
  // baseline highlight.
  var tries = 0, poll = setInterval(function(){
    runAll();
    if (++tries >= 24) clearInterval(poll);
  }, 350);

  // Mutation observer catches drawer toggles / theme re-renders.
  try {
    var obsTimer = null;
    var mo = new MutationObserver(function(){
      clearTimeout(obsTimer);
      obsTimer = setTimeout(runAll, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style','class','hidden','aria-hidden','value'] });
  } catch(e){}
})();
